export default __webpack_public_path__ + "static/media/logout-icon.e9fd2851.svg";